import {
  createDataReducer,
  getDataReducerInitialState,
} from "@ea/shared_components/redux/reducers/common.data.reducer";

import { moduleActions } from "./auditTrailScriptOverview.actions";
import { AuditTrailScriptOverview } from "@ea/shared_types/types";

const initialState = {
  ...getDataReducerInitialState<AuditTrailScriptOverview>(),
};

export type AuditTrailScriptOverviewReducer = typeof initialState;

const dataReducer = createDataReducer<AuditTrailScriptOverview>({
  ...moduleActions.table,
  ...moduleActions.data,
});

export const reducer = dataReducer(initialState);
